import { Chart } from 'react-google-charts';
import { useTranslation } from 'react-i18next';

export const HistogramChart = ({ histogram }: { histogram: number[][] }) => {
  const { t } = useTranslation();

  const options = {
    legend: { position: 'top', maxLines: 2 },
    colors: ['#9EC597', '#E27ADC'],
    interpolateNulls: false,
    isStacked: true,
    hAxis: {
      ticks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      title: t('measurements.histogramXAxis'),
      titleTextStyle: { color: '#7E7E7E' },
    },
    vAxis: {
      title: t('measurements.histogramYAxis'),
      titleTextStyle: { color: '#7E7E7E' },
    },
    histogram: {
      bucketSize: 1,
      hideBucketItems: true,
    },
  };

  return (
    <div className="flex flex-col">
      <h2 className="font-semibold text-gray-600">{t('measurements.histogramTitle')}</h2>
      <Chart
        graphID="step-histogram"
        height="400px"
        data={histogram}
        options={options}
        chartType="Histogram"
      />
    </div>
  );
};
